import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import {
  ModalGlobalStyle,
  Wrapper,
  CertificatesWrapper,
  Title,
  SecondaryText,
  Text,
  Separator,
  CertificateRow,
  CertificateWrapper
} from './styles';
import Modal from '@spa/shared/components/Modal';
import EnergyCertificationLabel from '@spa/shared/components/EnergyCertificationLabel';
import { EnergyCertificateGradesList } from './EnergyCertificateGradesList';

const EnergyCertificationModal = ({ onClose, ...props }) => {
  const { t } = useTranslation();

  return (
    <Modal className="energy-certification" onClose={onClose} title={t('Energy Certification')}>
      <ModalGlobalStyle />
      <Wrapper>
        <EnergyCertificateGradesList />
        <CertificatesWrapper>
          <EnergyCertificate {...props} />
          <Separator />
          <EmissionsCertificate {...props} />
        </CertificatesWrapper>
      </Wrapper>
    </Modal>
  );
};

const EnergyCertificate = ({ energyCertificateGrade, yearlyEnergyConsumption }) => {
  const { t } = useTranslation();

  return (
    <CertificateWrapper>
      <CertificateRow>
        <Title>{t('Energy certificate')}</Title>
        {energyCertificateGrade ? <EnergyCertificationLabel grade={energyCertificateGrade} /> : <RequestedMessage />}
      </CertificateRow>
      <CertificateRow>
        <Text>{t('Yearly energy consumption')}</Text>
        {yearlyEnergyConsumption ? (
          <SecondaryText>{yearlyEnergyConsumption} kWh/m²</SecondaryText>
        ) : (
          <RequestedMessage />
        )}
      </CertificateRow>
    </CertificateWrapper>
  );
};

const EmissionsCertificate = ({ emissionsCertificateGrade, yearlyEmissions }) => {
  const { t } = useTranslation();

  return (
    <CertificateWrapper>
      <CertificateRow>
        <Title>{t('Emissions certificate')}</Title>
        {emissionsCertificateGrade ? (
          <EnergyCertificationLabel grade={emissionsCertificateGrade} />
        ) : (
          <RequestedMessage />
        )}
      </CertificateRow>
      <CertificateRow>
        <Text>{t('Yearly emissions')}</Text>
        {yearlyEmissions ? <SecondaryText>{yearlyEmissions} kg CO2/m²</SecondaryText> : <RequestedMessage />}
      </CertificateRow>
    </CertificateWrapper>
  );
};

const RequestedMessage = () => {
  const { t } = useTranslation();

  return <SecondaryText>{t('Requested')}</SecondaryText>;
};

EnergyCertificationModal.propTypes = {
  onClose: PropTypes.func,
  energyCertificateGrade: PropTypes.string,
  yearlyEnergyConsumption: PropTypes.number,
  emissionsCertificateGrade: PropTypes.string,
  yearlyEmissions: PropTypes.number
};

EnergyCertificate.propTypes = {
  energyCertificateGrade: PropTypes.string,
  yearlyEnergyConsumption: PropTypes.number
};

EmissionsCertificate.propTypes = {
  emissionsCertificateGrade: PropTypes.string,
  yearlyEmissions: PropTypes.number
};

export default EnergyCertificationModal;
